<template>
  <div class="timer">
    {{ actualTime }}
  </div>
</template>

<script>
export default {
  props: {
    lastMessage: {
      type: String,
    },
  },
  data() {
    return {
      actualTime: '',
      timer: null,
    };
  },
  methods: {
    getTime() {
      const duration = this.actualTimeDifference(this.lastMessage);
      const format = duration.format('HH:mm:ss');

      if (duration.minutes() === 0 && duration.hours() === 0) {
        this.actualTime = `00:${format}`;
      } else {
        this.actualTime = duration.format('HH:mm:ss');
      }
    },
  },
  mounted() {
    this.timer = setInterval(() => {
      this.getTime();
    }, 200);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style lang="scss" scoped>
.timer {
  min-width: 70px;
}
</style>
